/*
全局添加的自定义 js 
*/

// 实现与 {{ xxx | handle }} 一样的功能
function handleize(str) {
  // 确保转换为字符串
  let result = str.toString()
    .toLowerCase()        // 转换为小写字母
    .replace(/\s+/g, '-') // 替换空格为连字符
    .replace(/[^\w\-]+/g, '-') // 移除非字母数字字符
    .replace(/--+/g, '-')   // 将多个连字符合并为一个
    .replace(/^-+/, '')     // 移除开头的连字符
    .replace(/-+$/, '');    // 移除结尾的连字符

  // 如果结果是以数字开头，则在前面加上下划线
  if (/^\d/.test(result)) {
    result = '_' + result;
  }

  return result;
}

// 滚动到指定元素位置
const scrollToTarget = (target) => {
  let mql = window.matchMedia('(max-width: 767px)');
  let isMobile = mql.matches;
  let fixedHeaderHeight = 0;
  let distance = window.scrollY + target.getBoundingClientRect().top;
  const fixHeaderNavigation = document.querySelector('.header-section');
  const ul = document.querySelector('#pProductOverviewMenu ul');
  const catalog = ul ? getComputedStyle(ul).height : '0px';
  if (fixHeaderNavigation) {
    const fixHeaderNavigationHeight = getComputedStyle(fixHeaderNavigation).height;
    fixedHeaderHeight = Number(fixHeaderNavigationHeight.replace('px', '')) + Number(catalog.replace('px', ''));
  }
  window.scrollTo(0, distance - fixedHeaderHeight + 1);
}

// PC 端浏览器切换到其他 Tab 页时，如果购物车不为空，修改当前 Tab 的标题
// 获取当前页面的原始标题
const originalTitle = document.title;
let currentTitle = originalTitle;
let tabInterval;
// 监听页面可见性变化事件
document.addEventListener('visibilitychange', function() {
  if (tabInterval) {
    clearInterval(tabInterval);
  }
  if (document.hidden) {
    theme.cart.getCart().then((val) => {
      const itemCount = val.item_count;
      if (itemCount) {
        tabInterval = setInterval(() => {
          currentTitle = currentTitle === originalTitle ? `👉 ${itemCount} items waiting for you` : originalTitle;
          document.title = currentTitle;
        }, 500)
      }
    })
  } else {
    // 页面切换到前台时，恢复原始标题
    document.title = originalTitle;
  }
});

/* 优化后的 resize 监听事件 */
;(function() {
    var throttle = function(type, name, obj) {
        obj = obj || window;
        var running = false;
        var func = function() {
            if (running) { return; }
            if (timeout) clearTimeout(timeout);
            running = true;
            var timeout = setTimeout(() => {
                obj.dispatchEvent(new CustomEvent(name));
                running = false;
            },500)
        };
        obj.addEventListener(type, func);
    };

    /* init - you can init any event */
    throttle("resize", "optimizedResize");
})();

/* 更新购物车按钮上的数字 */

function updateCartCountNumber(obj) {
var cartBubble = document.querySelector('.cart-link__bubble');
var cartCountSelector = document.querySelector('.cartCountSelector');
cartBubble.innerText = obj.num;
cartCountSelector.innerText = obj.num;

};
// 返回购物车总的 item 数量
document.addEventListener('ajaxProduct:added', function(evt) {
  theme.cart.getCart().then((val) => {
    const itemCount = val.item_count;
    console.log('added!!',itemCount)
    updateCartCountNumber({
      type: 'add',
      num: itemCount
    })
  })
});
// 返回购物车剩下的 item 数量
document.addEventListener('cart:updated', function(e) {
  console.log('updated!!');
  var cart = e.detail.cart;
  if (cart) {
    updateCartCountNumber({
      type: 'update',
      num: cart.item_count
    })
  }
});
// 打开抽屉时隐藏 smile 插件
document.addEventListener('drawerOpen', function() {
  const smileApp = document.querySelector('.js-drawer-open:not(.js-drawer-open--search) #smile-ui-lite-container');
  if (smileApp) smileApp.style.zIndex = 10;
});



// 全局脚本
function setFormNote(dataObject) {
  hideBtns();
  const productFormList = document.querySelectorAll('form[action="/cart/add"]');
  if (productFormList.length) {
    let countryCode = 'US';
    const origin = location.origin;
    if (origin.includes('ca.')) {
      countryCode = 'CA';
    } else if (origin.includes('au.')) {
      countryCode = 'AU';
    } else if (origin.includes('jp.')) {
      countryCode = 'JP';
    } else if (origin.includes('de.')) {
      countryCode = 'DE';
    } else if (origin.includes('fr.')) {
      countryCode = 'FR';
    }
    productFormList.forEach((item) => {
      const channelNote = document.createElement('input');
      const channelUserIdNote = document.createElement('input');
      const channelCountryCodeNote = document.createElement('input');
      channelNote.setAttribute('type', 'text');
      channelUserIdNote.setAttribute('type', 'text');
      channelCountryCodeNote.setAttribute('type', 'text');
      
      channelNote.setAttribute('name', 'attributes[channel]');
      channelUserIdNote.setAttribute('name', 'attributes[channelUserId]');
      channelCountryCodeNote.setAttribute('name', 'attributes[channelCountryCode]');
      
      channelNote.classList.add('hide');
      channelUserIdNote.classList.add('hide');
      channelCountryCodeNote.classList.add('hide');
      
      if (dataObject) {
        channelNote.value = dataObject.channel;
        channelUserIdNote.value = dataObject.userId;
        channelCountryCodeNote.value = countryCode;
        
        item.appendChild(channelNote);
        item.appendChild(channelUserIdNote);
        item.appendChild(channelCountryCodeNote);
      }
    })
  }
}


// 接收来自 APP 的数据
function receiveDataFromApp(data) {
  setFormNote(data);
}

// 隐藏详情页的加购插件的按钮和直接跳转结账页的按钮
function hideBtns() {
  const style  = document.createElement('style');
  style.type = 'text/css';  
  const cssContent = `  
    [data-shopify="payment-button"],
    .additional-checkout-buttons,
    .cbb-frequently-bought-container,
    #bundle-sticky_add_to_cart.Vtl-StickyAddToCart,
    #sticky_add_to_cart_root,
    #bundle-sticky_add_to_cart {
      display: none !important;
      width: 0 !important;
      height: 0 !important;
      overflow: hidden !important;
    }
    .drawer .cart__checkout {
      width: 100% !important;
    }
  `;
  style.appendChild(document.createTextNode(cssContent));
  document.head.appendChild(style); 
}

document.addEventListener('DOMContentLoaded', () => {
  try {
    // iOS 平台，先发送一个空信息给 APP，然后 APP 会调用约定好的 receiveDataFromApp 函数，传入data然后绑定到 form
    window.webkit.messageHandlers.getDataFromApp.postMessage(null);
  } catch (error) {
    if (typeof AndroidApp !== 'undefined' && AndroidApp) {
     // Android 平台，直接接收到数据然后绑定到 form
    const jsonString = AndroidApp.getDataFromApp();
    const dataObject = JSON.parse(jsonString); // 解析 JSON 字符串
    setFormNote(dataObject);
   }
  }
})